var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useEffect, useState } from 'react';
import { Drawer, colorPalette } from '@next-common/mui';
import StoreIcon from '@mui/icons-material/Store';
import StarIcon from '@mui/icons-material/Star';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import { EshopDetail } from './EshopDetail';
import { EshopReview } from './EshopReview';
import { DataForEshopSellerReviewDataApi } from '../../services/eshop-header-api/codegenClient';
import { useQuery } from '@tanstack/react-query';
export const EshopDrawer = ({ open, onClose, title, target, setTarget, seller }) => {
    const [selectedTab, setSelectedTab] = useState(target === 'review' ? 1 : 0);
    const [tabs, setTabs] = useState();
    const reviewApi = new DataForEshopSellerReviewDataApi(undefined, '');
    const { data: reviewData } = useQuery({
        queryKey: ['getEshopSellerReviewData', 'RATE', 'DESC'],
        queryFn: () => __awaiter(void 0, void 0, void 0, function* () {
            var _a;
            if (!(seller === null || seller === void 0 ? void 0 : seller.id))
                return;
            const result = yield reviewApi.getEshopSellerReviewData(((_a = seller === null || seller === void 0 ? void 0 : seller.id) === null || _a === void 0 ? void 0 : _a.toString()) || '', 'RATE', 'DESC', 20);
            return result;
        }),
    });
    useEffect(() => {
        if (target === 'detail') {
            setSelectedTab(0);
        }
        else {
            setSelectedTab(1);
        }
    }, [target]);
    useEffect(() => {
        if (open) {
            document.body.style.overflow = 'hidden';
        }
        else {
            document.body.style.overflow = '';
        }
        return () => {
            document.body.style.overflow = '';
        };
    }, [open]);
    useEffect(() => {
        if (!(seller === null || seller === void 0 ? void 0 : seller.isCrew)) {
            setTabs([
                {
                    label: (React.createElement(Stack, { alignItems: "center", direction: "row", spacing: 1 },
                        React.createElement(StoreIcon, { sx: {
                                fontSize: '20px',
                                color: selectedTab === 1 ? colorPalette.gray300 : colorPalette.gray700,
                            } }),
                        React.createElement(Typography, null, "D\u00E9tails vendeur"))),
                    value: 0,
                    children: React.createElement(EshopDetail, { seller: seller }),
                },
                {
                    label: (React.createElement(Stack, { alignItems: "center", direction: "row", spacing: 1 },
                        React.createElement(StarIcon, { sx: {
                                fontSize: '20px',
                                color: selectedTab === 0 ? colorPalette.gray300 : colorPalette.yellow500,
                            } }),
                        React.createElement(Typography, null, "Avis sur le vendeur"))),
                    value: 1,
                    disabled: (reviewData === null || reviewData === void 0 ? void 0 : reviewData.status) === 204 ? true : false,
                    children: React.createElement(EshopReview, { seller: seller }),
                },
            ]);
        }
        else {
            setTabs([
                {
                    label: (React.createElement(Stack, { alignItems: "center", direction: "row", spacing: 1 },
                        React.createElement(StoreIcon, { sx: {
                                fontSize: '20px',
                                color: selectedTab === 1 ? colorPalette.gray300 : colorPalette.gray700,
                            } }),
                        React.createElement(Typography, null, "D\u00E9tails vendeur"))),
                    value: 0,
                    children: React.createElement(EshopDetail, { seller: seller }),
                },
            ]);
        }
    }, [seller, selectedTab, reviewData === null || reviewData === void 0 ? void 0 : reviewData.status]);
    const onChangeTab = (index) => {
        if (index === 0) {
            setTarget('detail');
        }
        else {
            setTarget('review');
        }
    };
    return (React.createElement(Drawer, { open: open, onClose: onClose, title: title, tabsProps: {
            variant: 'fullWidth',
            indicatorColor: 'secondary',
            textColor: 'secondary',
        }, selectedTab: selectedTab, onChangeTab: onChangeTab, tabs: tabs }));
};
